export default "<app-menu></app-menu>\n<!-- <app-side-menu #sidenav></app-side-menu> -->"